// extracted by mini-css-extract-plugin
module.exports = {"avatarWithName":"avatarWithName__u8pS7","content":"content__0xLOW","subContent":"subContent__HgqsP"};